import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

import classes from "./header.module.scss"

const Header = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "lab.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }

      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 120) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  return (
    <header className={classes.Header}>
      <div className={classes.Content} id="header">
        <Img
          fixed={data.logo.childImageSharp.fixed}
          fadeIn={false}
          alt="Logo"
        />

        <div className={classes.Text}>
          <h1>Laboratorio Bioquímico Debat</h1>
          <p>
            Laboratorio de análisis clínicos de Gobernador Virasoro, Corrientes.
          </p>
          <a
            className={classes.Button}
            href="https://api.whatsapp.com/send?phone=543756491471"
            target="__blank"
          >
            Pedir Turno
          </a>
        </div>
      </div>

      <Img
        fluid={data.image.childImageSharp.fluid}
        className={classes.Background}
        alt="Fondo laboratorio"
        fadeIn={false}
      />
    </header>
  )
}

export default Header
